
import axios from 'axios';
import React, { Component }  from 'react';


export class PreloadOrder extends Component {
  constructor(props) {
    super(props);


    this.state = {
      loading: true
    }
  }

  componentDidMount() {
    const { id, onUpdate, apiUrl = 'order' } = this.props;
    if (id) {
      axios.get(`${apiUrl}/${id}`).then(res => {
        const obj = res.data;
        let newObj = {
          order_type: obj.order_type,
          client: obj.client,
          counterparty: obj.counterparty,
          contact_persons: obj.contact_persons,
          carrier: obj.carrier,
          tariff: obj.tariff,
          date_start: obj.date_start,
          date_end: obj.date_end,
          container_owner: obj.container_owner,
          container_type: obj.container_type,
          hbl_date: obj.hbl_date,
          station_arrival_date: obj.station_arrival_date,
          cargo_weight: obj.cargo_weight,
          description: obj.description,
          shipper: obj.shipper,
          consignee: obj.consignee
        };

        let newPoints = [];
        obj.points.forEach(point => {
          let newServices = [];
          point.services.forEach(service => {
            newServices.push({
              quantity: service.quantity,
              cost: service.cost,
              service: service.service
            })
          });
          newPoints.push({
            services: newServices,
            point: point.point,
            point_text: point.point_text,
            point_address: point.point_address,
            point_display: point.point_display,
            date: null
          })
        });
        newObj.points = newPoints;

        let newExtraServices = [];
        obj.extra_services.forEach(extraService => {
          newExtraServices.push({
            quantity: extraService.quantity,
            cost: extraService.cost,
            service: extraService.service
          })
        });
        newObj.extra_services = newExtraServices;

        onUpdate(newObj);

        this.setState({
          loading: false
        });
      })
    }
    else {
      this.setState({
        loading: false
      })
    }
  }

  render() {
    const { loading } = this.state;
    if (loading)
      return <React.Fragment />;

    return <React.Fragment>{this.props.children}</React.Fragment>
  }
}
